// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2XOg8","author":"Table_author__1Iil4","authorImage":"Table_authorImage__3cQt1","unreadRow":"Table_unreadRow__2nbbK"};